import Link from "./Link";

export default function ExternalLink({ text, url }) {
  return <Link text={text} onClick={() => window.open(url)} />;
}
